import React from 'react';
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import cx from 'classnames';

import {RUOLI} from "../../../../applicationConf";

import globalBoostrapStyle from '../../../../assets/global-style/bootstrap.module.css'
import headerModuleStyle from '../css/Header.module.css';


const DataUser = (props) => {

    const configurationFile = useSelector(state => state.configurationFile);
    const auth = useSelector(state => state.auth)

    const nameRef = React.useRef(null);
    const dataUserRef = React.useRef(null);
    const userDiv = React.useRef(null);
    const navbarDropdownMenu = React.useRef(null);

    const closeDataUser = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (userDiv.current != null) {
            if (!userDiv.current.contains(e.target)) {
                if (!dataUserRef.current.contains(e.target) && navbarDropdownMenu.current.classList.contains('show')) {
                    navbarDropdownMenu.current.classList.toggle('show');
                    nameRef.current.classList.toggle(headerModuleStyle.not_active);
                    window.removeEventListener('click', closeDataUser, false);
                }
            }
        } else {
            window.removeEventListener('click', closeDataUser, false);
        }
    };

    const openDataUser = () => {
        if (navbarDropdownMenu.current != null) {
            if (!navbarDropdownMenu.current.classList.contains('show')) {
                navbarDropdownMenu.current.classList.toggle('show');
                nameRef.current.classList.toggle(headerModuleStyle.not_active);
                window.addEventListener('click', closeDataUser, false);
            } else {
                navbarDropdownMenu.current.classList.toggle('show');
                nameRef.current.classList.toggle(headerModuleStyle.not_active);
                window.removeEventListener('click', closeDataUser, false);
            }
        }
    };

    return (
        <>
            <div className={cx(headerModuleStyle.style__user)}
                 style={{minWidth: auth.user != null ? '176px' : null}}
                 ref={userDiv}
                 onClick={() => openDataUser()}>

                {auth.user != null ? <i className='fa fa-user-circle-o fa-lg text-muted'/> : null}

                <div className={cx(globalBoostrapStyle['nav-link'], headerModuleStyle.not_active)}
                     ref={nameRef}
                     style={{cursor: 'pointer', marginRight: auth.user != null ? null : '10px'}}>
                    {auth.user != null ? `${auth.user['USER_NAME']} ${auth.user['USER_SURNAME']}` : 'Utente'}
                </div>
                <div className='custom__caret'/>
            </div>
            <div style={{position: 'relative'}}
                 ref={dataUserRef}>
                <div className="dropdown-menu dropdown-menu-right shadow"
                     style={{minWidth: '330px'}}
                     ref={navbarDropdownMenu}>
                    {auth.user != null ? (
                        <>
                            <p className="dropdown-item__custom text-muted m-0">
                                <strong>
                                    <em>Codice Fiscale:</em>
                                </strong>
                                <span style={{
                                    letterSpacing: '1px',
                                    fontSize: '15px',
                                    marginLeft: '10px'
                                }}>
                                    {auth.user['USER_CF']}
                                </span>
                            </p>
                            <p className="dropdown-item__custom text-muted m-0">
                                <strong>
                                    <em>Nome:</em>
                                </strong>
                                <span style={{
                                    letterSpacing: '1px',
                                    fontSize: '15px',
                                    marginLeft: '10px'
                                }}>
                                    {auth.user['USER_NAME']}
                                </span>
                            </p>
                            <p className="dropdown-item__custom text-muted m-0">
                                <strong>
                                    <em>Cognome:</em>
                                </strong>
                                <span style={{
                                    letterSpacing: '1px',
                                    fontSize: '15px',
                                    marginLeft: '10px'
                                }}>
                                    {auth.user['USER_SURNAME']}
                                </span>
                            </p>
                            <p className="dropdown-item__custom text-muted m-0 text-capitalize">
                                <strong>
                                    <em>Ruolo:</em>
                                </strong>
                                <span style={{
                                    letterSpacing: '1px',
                                    fontSize: '15px',
                                    marginLeft: '10px'
                                }}>
                                    {auth.ruoloScelto ? RUOLI[auth.ruoloScelto.toUpperCase()].RUOLO : ''}
                                </span>
                            </p>

                            <hr className='m-2'/>
                        </>
                    ) : null}

                    <div style={{padding: '4px 24px'}}>
                        <h6 className='text-muted'>
                            <strong>
                                Versions
                            </strong>
                        </h6>
                        <ul className='pl-3 pr-0 pt-3 pb-0 m-0'>
                            <li className='d-inline-flex flex-wrap align-items-center justify-content-between w-100'>
                                <p style={{fontWeight: '700', color: '#5c92109e'}}>Rec_web</p>
                                <p className='text-muted'>{configurationFile.versionFrontEnd}</p>
                            </li>
                            <li className='d-inline-flex flex-wrap align-items-center justify-content-between w-100'>
                                <p style={{fontWeight: '700', color: '#944317c7'}}>Rec_server</p>
                                <p className='text-muted'>{configurationFile.versionBackEnd}</p>
                            </li>
                        </ul>
                    </div>

                    <hr className='m-2'/>

                    <Link to='/login'
                          id='innerLogoutDataUser'
                          className="dropdown-item__custom pt-2"
                          style={{cursor: 'pointer'}}
                          onClick={props.cleanSessionStorage}>
                        <button className="btn btn-sm btn-primary float-right shadow">
                            Logout
                        </button>
                    </Link>
                    <div className='clearfix'/>
                </div>
            </div>
        </>
    )
};

DataUser.propTypes = {
    user: PropTypes.shape({
        USER_CF: PropTypes.string,
        USER_NAME: PropTypes.string,
        USER_SURNAME: PropTypes.string,
        applicativo: PropTypes.shape({
            id: PropTypes.string,
            nome: PropTypes.string,
            dominioApplicativo: PropTypes.string
        }),
        dominioApplicativo: PropTypes.string,
        id: PropTypes.string,
        nome: PropTypes.string,
        aud: PropTypes.string,
        exp: PropTypes.number,
        iat: PropTypes.number,
        iss: PropTypes.string,
        sub: PropTypes.string,
        user: PropTypes.string,
    }),
    ruoloScelto: PropTypes.string,
    recWebVersion: PropTypes.string,
    recServerVersion: PropTypes.string,
    cleanSessionStorage: PropTypes.func
};

export default DataUser;



